import '@babel/polyfill';
import 'typeface-roboto';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import appReducer from './reducers/index';
import App from './components/App.js';
import * as Utils from "./utils";
import _ from "lodash";

/*
 * Realiza as configurações iniciais.
 */
let preloadedState = {};

const queryStringParsed = Utils.queryStringParsed();

if (queryStringParsed) {
    if (queryStringParsed.header) {
        preloadedState = _.assign({}, preloadedState, {
            showHeader: queryStringParsed.header === 'true'
        });
    }

    if (queryStringParsed.ps) {
        preloadedState = _.assign({}, preloadedState, {
            ps: queryStringParsed.ps
        });
    }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(appReducer,  preloadedState, composeEnhancers(
    applyMiddleware(
        thunk
    )
));

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);